export default __webpack_public_path__ + "853356a9b5820604f8fa86dd735c7eea.webp";